import { usersService } from '../services';
import { isValidWorkspace, STORAGE_KEYS } from '../config/workspaceExperience';
import { ONBOARDING_STORAGE_KEY } from '../config/onboardingConfig';

/**
 * Write server preferences to localStorage only (no React events).
 */
export function hydrateWorkspaceFromUserPreferences(preferences) {
  if (!preferences || typeof preferences !== 'object') return;

  const { workspaceExperience, showDeveloperTools, onboardingComplete } = preferences;

  if (workspaceExperience && isValidWorkspace(workspaceExperience)) {
    localStorage.setItem(STORAGE_KEYS.experience, workspaceExperience);
  }
  if (typeof showDeveloperTools === 'boolean') {
    localStorage.setItem(STORAGE_KEYS.showDeveloperTools, showDeveloperTools ? 'true' : 'false');
  }
  if (onboardingComplete === true) {
    localStorage.setItem(ONBOARDING_STORAGE_KEY, 'true');
  }
}

/**
 * Persist workspace UX fields to user.preferences via API (POST).
 */
export async function persistWorkspacePreferences(patch) {
  if (!patch || typeof patch !== 'object') return;
  try {
    await usersService.preferencesUpdate({ preferences: patch });
  } catch (err) {
    console.warn('[workspace] Failed to sync preferences to server', err);
  }
}
